module.exports = __webpack_public_path__ + "static/img/viral_19.48683f82.jpg";